import {
  styled,
  Box,
  Typography,
  IconButton,
  Card,
  Button,
} from "@mui/material";
import colors from "../../theme/Colours";

export const EditableFieldContainer = styled(Box)({
  display: "flex",
});

export const SearchRowContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  marginBottom: 16,
  marginLeft: 32,
});

export const EditableTextFieldStyles = {
  padding: "1px",
  fontSize: "12px",
  "& .MuiInputBase-input": {
    fontSize: "11.63px",
    padding: "4px",
  },
};

export const EditableDisplayContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  fontSize: "11.63px",
});

export const PencilIconButton = styled(IconButton)({
  marginLeft: 4,
});

export const ShipmentCard = styled(Card)({
  paddingTop: "32px",
  paddingBottom: "8px",
  boxShadow: "6px",
  borderRadius: "4px",
});

export const OrderDetailsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const OrderIdText = styled(Typography)({
  fontSize: "10.66px",
});

export const PriceText = styled(Typography)({
  fontSize: "11.63px",
  fontWeight: 600,
});

export const SummaryButton = styled(Button)({
  width: "auto",
  padding: "8px 16px",
  marginRight: "16px",
  backgroundColor: colors.primaryButtonOrange,
  borderRadius: "4px",
});

export const SummaryButtonContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
});

export const FooterContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  margin: 16,
});

export const FooterText = styled(Typography)({
  color: colors.borderGrey,
  fontFamily: "Poppins, sans-serif",
});

export const EditableIconButton = styled(IconButton)({
  width: 16,
  height: 16,
});

export const OrangeCheckboxStyle = {
  color: colors.greyBackground,
  "&.Mui-checked": {
    color: colors.primaryButtonOrange,
    "& .MuiSvgIcon-root": {
      backgroundColor: "transparent",
      border: "none",
    },
  },
};

export const LocationText = styled(Box)({
  maxWidth: "160px", //20 characters wide
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  fontSize: "11.63px",
  lineHeight: "1.4",
});
